import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {PlanningEquipesSupplier} from '../../../../shared/ui/gestion-unitesproduction/planning-equipes/PlanningEquipesSupplier';
import {PlanningEquipesService} from '../../../../core/services/gestion-unites-productions/planning-equipes.service';
import {TYPE_TACHE} from '../../../../core/services/entities/type-tache.service';

@Injectable({
  providedIn: 'root'
})
export class PlanningApprovisionnementsResolverService implements Resolve<PlanningEquipesSupplier> {

  constructor(private planningEquipesSvc: PlanningEquipesService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PlanningEquipesSupplier> | Promise<PlanningEquipesSupplier> | PlanningEquipesSupplier {
    return this.planningEquipesSvc.resolve(route, state, TYPE_TACHE.APPROVISIONNEMENT,30);
  }

}
